import { Component } from '@angular/core';
import { Http } from "@angular/http";

import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../Services/auth.service';
import { MiraieService } from '../Services/miraie.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { MatchingService } from '../Services/matching.service';
import { FormService } from "../Services/form.service";
import { ScService } from '../search-data/sc.service';
import * as constant from '../constant';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['../customer-input/customer-input.component.css']
})
export class CustomerDetailComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  sc = this.scService.sc;
  detail: any = {
    division_code: "",
    del_chk: "",
  };
  question: any = {};
  point: any = {};
  schedule: any = {};
  interview: any = {
    user_calendar_code: 0,
    date: {},
    start_hour: "",
    start_minute: "",
    end_hour: "",
    end_minute: "",
    user_code: "",
    title: "",
    contents: "",
    upfile: "",
  };
  interview_edit: any;
  itvw_imgname: string;
  imglists: any;
  noticelists: any;
  divisions: any;
  users: any;
  sales_users: any;
  construction_users: any;
  place_list: any;
  detail_update_list: any;
  detail_interview_list: any;
  Prefectures: string[];
  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;
  br_flg = false;
  ip_flg = false;
  tm_pay_c: number = 0;
  tm_pay_p: number = 0;
  tm_pay_name_c = "";
  tm_pay_name_p = "";
  nm_pay_c: number = 0;
  nm_pay_p: number = 0;
  nm_pay_name_c = "";
  nm_pay_name_p = "";
  message: string;
  error: string;
  srcurl: string;
  modalReference: NgbModalRef;

  //デフォルトで表示するタブ
  tab = this.formService.tab;
  active = this.formService.active;

  //タブ切り替え
  _handleClick(event: MouseEvent): void {
    const element = event.currentTarget as HTMLElement;
    const tabState = element.getAttribute('aria-controls');
    this.tab = tabState;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private miraieService: MiraieService,
    public customerInputService: CustomerInputService,
    private scService: ScService,
    private formService: FormService,
    public matchingService: MatchingService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.sc = this.scService.sc;
    this.tab = this.formService.tab;
    this.active = this.formService.active;
    this.br_flg = this.matchingService.br_flg;
    this.ip_flg = this.customerInputService.ip_flg;
    this.srcurl = this.miraieService.srcurl;
    let paramTab = this.route.snapshot.paramMap.get('tab');
    if (paramTab && paramTab != '0') {
      this.tab = 'panel' + paramTab;
    }
    let paramRef = this.route.snapshot.paramMap.get('ref');
    if (paramRef && paramRef != '0') {
      this.active = 'static-' + paramRef;
    }
    const customer_code = +this.route.snapshot.paramMap.get('id');
    //console.log( customer_code );
    if (customer_code) {
      //顧客情報
      let detail = this.customerInputService.customerDetail(customer_code);
      detail.subscribe(detail => {
        this.detail = detail['detail'];
        this.question = detail['question'];
        if (this.question.a1) {
          this.question.a1 = this.question.a1.split(",");
        }
        if (this.question.a3) {
          this.question.a3 = this.question.a3.split(",");
        }
        if (this.question.a8) {
          this.question.a8 = this.question.a8.split(",");
        }
        this.point = detail['point'];
        this.schedule = detail['schedule'];
        this.active = this.schdule_def(this.schedule, this.active);

        //入金予定
        this.schedulePayment_sum();
        this.schedulePayment_plan();
      });

      //更新履歴
      let List = this.customerInputService.customerUpdateList(customer_code);
      List.subscribe(List => {
        this.detail_update_list = List;
      });
      this.interview.user_code = this.detail.sales_contact_code;
      //面談履歴一覧取得
      let List2 = this.customerInputService.customerInterviewList(customer_code);
      List2.subscribe(List2 => {
        this.detail_interview_list = List2;
      });
      //画像集一覧取得
      let List3 = this.customerInputService.customerImglistList(customer_code);
      List3.subscribe(List3 => {
        this.imglists = List3;
      });
      //注意一覧取得
      let List4 = this.customerInputService.customerNoticeList(customer_code);
      List4.subscribe(List4 => {
        this.noticelists = List4;
      });
    }

    this.Prefectures = this.formService.getPrefectures();
    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['user'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
    });
  }

  //戻るﾎﾞﾀﾝ
  backResult() {
    //console.log(this.ip_flg);
    if (this.br_flg) {
      this.router.navigate(['/matching-list/']);
    } else if (this.ip_flg) {
      this.router.navigate(['/input/']);
    } else {
      this.scService.sc = this.sc;
      this.formService.tab = this.tab;
      this.formService.active = this.active;
      this.router.navigate(['/result/']);
    }
  }

  //顧客情報編集
  customerUpdate() {
    this.scService.sc = this.sc;
    this.formService.tab = this.tab;
    this.formService.active = this.active;
    const customer_code = +this.route.snapshot.paramMap.get('id');
    this.router.navigate(['/input/' + customer_code]);
  }

  //工程情報デフォルト
  schdule_def(schedule, active) {
    const today = new Date();

    //営業：契約日
    if (schedule.contract_date) {
      if (today > new Date(schedule.contract_date + 'T24:00:00')) {
        active = "static-2";
      }
    } else {
      //工程の日程（予定）過ぎても実績日なかったら、アラート＞そのタブ開く

    }

    //土地：決済実績日
    if (schedule.land_settlement_result_date) {
      if (today > new Date(schedule.land_settlement_result_date + 'T24:00:00')) {
        active = "static-3";
      }
    }

    //融資：金消契約日
    if (schedule.money_consumpltion_agree) {
      if (today > new Date(schedule.money_consumpltion_agree + 'T24:00:00')) {
        active = "static-4";
      }
    }

    //土地：地盤改良工事日
    if (schedule.ground_improvement_date) {
      if (today > new Date(schedule.ground_improvement_date + 'T24:00:00')) {
        active = "static-5";
      }
    }

    //プラン：引渡日
    if (schedule.delivery_date) {
      if (today > new Date(schedule.delivery_date + 'T24:00:00')) {
        active = "all-close";
      }
    }

    return active;
  }



  //合計契約金算出
  schedulePayment_sum() {
    if (this.schedule.contract_payment && this.schedule.contract_payment_add) {
      this.schedule.contract_payment_sum = parseInt(this.schedule.contract_payment) + parseInt(this.schedule.contract_payment_add);
    } else {
      if (this.schedule.contract_payment_add) {
        this.schedule.contract_payment_sum = this.schedule.contract_payment_add;
      } else {
        this.schedule.contract_payment_sum = this.schedule.contract_payment;
      }
    }
  }
  //入金取得用
  schedulePayment_plan() {
    this.tm_pay_p = 0;
    this.tm_pay_name_p = "";
    this.tm_pay_c = 0;
    this.tm_pay_name_c = "";
    this.nm_pay_p = 0;
    this.nm_pay_name_p = "";
    this.nm_pay_c = 0;
    this.nm_pay_name_c = "";
    var count_t_p = 0;
    var count_t_c = 0;
    var count_n_p = 0;
    var count_n_c = 0;
    let now_date = new Date();
    let now_year = now_date.getFullYear();
    let now_month = now_date.getMonth() + 1;
    let next_date = new Date();
    next_date.setMonth(next_date.getMonth() + 2);
    let next_year = next_date.getFullYear();
    let next_month = next_date.getMonth();
    let c_date = new Date(this.schedule.construction_payment_plandate);
    let c_year = c_date.getFullYear();
    let c_month = c_date.getMonth() + 1;
    let c_date_c = new Date(this.schedule.construction_payment_date);
    let c_year_c = c_date_c.getFullYear();
    let c_month_c = c_date_c.getMonth() + 1;
    let m_date = new Date(this.schedule.midway_payment_plandate);
    let m_year = m_date.getFullYear();
    let m_month = m_date.getMonth() + 1;
    let m_date_c = new Date(this.schedule.midway_payment_date);
    let m_year_c = m_date_c.getFullYear();
    let m_month_c = m_date_c.getMonth() + 1;
    let f_date = new Date(this.schedule.final_payment_plandate);
    let f_year = f_date.getFullYear();
    let f_month = f_date.getMonth() + 1;
    let f_date_c = new Date(this.schedule.final_payment_date);
    let f_year_c = f_date_c.getFullYear();
    let f_month_c = f_date_c.getMonth() + 1;

    //今月
    if (this.schedule.construction_payment_date && this.schedule.construction_payment) {
      //着工金：入金
      if (c_year_c === now_year && c_month_c === now_month) {
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.construction_payment);
        this.tm_pay_name_c += "着工金";
        count_t_c++;
      }
    } else {
      //着工金：予定
      if (c_year === now_year && c_month === now_month) {
        if (this.schedule.construction_payment_plan) {
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.construction_payment_plan);
          this.tm_pay_name_p += "着工金";
          count_t_p++;
        }
      }
    }

    if (this.schedule.midway_payment_date && this.schedule.midway_payment) {
      //中間金：入金
      if (m_year_c === now_year && m_month_c === now_month) {
        if (count_t_c > 0) {
          this.tm_pay_name_c += "/";
        }
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.midway_payment);
        this.tm_pay_name_c += "中間金";
        count_t_c++;
      }
    } else {
      //中間金：予定
      if (m_year === now_year && m_month === now_month) {
        if (this.schedule.midway_payment_plan) {
          if (count_t_p > 0) {
            this.tm_pay_name_p += "/";
          }
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.midway_payment_plan);
          this.tm_pay_name_p += "中間金";
          count_t_p++;
        }
      }
    }

    if (this.schedule.final_payment_date && this.schedule.final_payment) {
      //最終金：入金
      if (f_year_c === now_year && f_month_c === now_month) {
        if (count_t_c > 0) {
          this.tm_pay_name_c += "/";
        }
        this.tm_pay_c = this.tm_pay_c + parseInt(this.schedule.final_payment);
        this.tm_pay_name_c += "最終金";
        count_t_c++;
      }
    } else {
      //最終金(引渡金)：予定
      if (f_year === now_year && f_month === now_month) {
        if (this.schedule.final_payment_plan) {
          if (count_t_p > 0) {
            this.tm_pay_name_p += "/";
          }
          this.tm_pay_p = this.tm_pay_p + parseInt(this.schedule.final_payment_plan);
          this.tm_pay_name_p += "最終金";
          count_t_p++;
        }
      }
    }

    //来月
    if (this.schedule.construction_payment_date && this.schedule.construction_payment) {
      //着工金：入金
      if (c_year_c === next_year && c_month_c === next_month) {
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.construction_payment);
        this.nm_pay_name_c += "着工金";
        count_n_c++;
      }
    } else {
      //着工金：予定
      if (c_year === next_year && c_month === next_month) {
        if (this.schedule.construction_payment_plan) {
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.construction_payment_plan);
          this.nm_pay_name_p += "着工金";
          count_n_p++;
        }
      }
    }

    if (this.schedule.midway_payment_date && this.schedule.midway_payment) {
      //中間金：入金
      if (m_year_c === next_year && m_month_c === next_month) {
        if (count_n_c > 0) {
          this.nm_pay_name_c += "/";
        }
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.midway_payment);
        this.nm_pay_name_c += "中間金";
        count_n_c++;
      }
    } else {
      //中間金：予定
      if (m_year === next_year && m_month === next_month) {
        if (this.schedule.midway_payment_plan) {
          if (count_n_p > 0) {
            this.nm_pay_name_p += "/";
          }
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.midway_payment_plan);
          this.nm_pay_name_p += "中間金";
          count_n_p++;
        }
      }
    }

    if (this.schedule.final_payment_date && this.schedule.final_payment) {
      //最終金：入金
      if (f_year_c === next_year && f_month_c === next_month) {
        if (count_n_c > 0) {
          this.nm_pay_name_c += "/";
        }
        this.nm_pay_c = this.nm_pay_c + parseInt(this.schedule.final_payment);
        this.nm_pay_name_c += "最終金";
        count_n_c++;
      }
    } else {
      //最終金(引渡金)：予定
      if (f_year === next_year && f_month === next_month) {
        if (this.schedule.final_payment_plan) {
          if (count_n_p > 0) {
            this.nm_pay_name_p += "/";
          }
          this.nm_pay_p = this.nm_pay_p + parseInt(this.schedule.final_payment_plan);
          this.nm_pay_name_p += "最終金";
          count_n_p++;
        }
      }
    }
  }
  //顧客情報：削除モーダル
  open_cd(customer_del) {
    this.detail.del_chk = "";
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalReference = this.modalService.open(customer_del, config);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }

  //顧客情報削除
  customerDel() {
    const customer_code = +this.route.snapshot.paramMap.get('id');
    let res = this.customerInputService.customerDel(customer_code);
    res.subscribe(res => {
      if (res['result'] == 'success') {
        this.message = "顧客情報を削除しました";
        this.error = "削除失敗";
        this.scService.sc = this.sc;
        this.formService.tab = this.tab;
        this.formService.active = this.active;
        this.router.navigate(['/result/']);
        //モーダル閉じる
        this.modalReference.close();
      } else {
        this.message = "";
        this.error = "削除失敗";
      }
    });
  }

  //面談履歴：画像モーダル
  open_itvw_img(itvw_img, imgname) {
    this.itvw_imgname = imgname;
    const config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalService.open(itvw_img, config).result.then((result) => { }, (reason) => { });
  }

}
